<template>
  <v-row>
    <!-- Fechas -->
    <v-col cols="12" lg="3">
      <date-selector label="Fecha Inicio" ref="fecha_inicio"/>
    </v-col>    
    <v-col cols="12" lg="3">
      <date-selector label="Fecha Fin" ref="fecha_fin"/>
    </v-col>  

    <!-- Alarmas posibles --> 
    <v-col cols="12" lg="1" >
      <v-checkbox
        v-model="selected"
        label="Potencia excedida en producción"
        value=4001
      ></v-checkbox>
    </v-col>    
    <v-col cols="12" lg="1" >
      <v-checkbox
        v-model="selected"
        label="Potencia excedida corte luz"
        value=4003
      ></v-checkbox>
    </v-col>   
    
    <v-col cols="12" lg="1" > 
      <v-checkbox
        v-model="selected"
        label="Caída tensión general"
        value=7
      ></v-checkbox>
    </v-col>   

    <!-- Botón para filtrar -->
    <v-col cols="12" lg="3" >
      <b-button class="btn-block" @click="getData">Filtrar</b-button>
    </v-col>    
 </v-row>

</template>
<script>
import DateSelector from '../DateSelector.vue';

export default {
  components: { DateSelector },
      data() {
      return {
               showPicker: false,
               showPicker1: false,
        selectedDate: null,
        selected:[]
      };
    },
    methods: {
        getData() {
            const payload = {
                'fecha_inicio':this.$refs.fecha_inicio.date,
                'fecha_fin':this.$refs.fecha_fin.date,
                'alarmas':this.selected
            }
            this.$emit('getData',payload)
            
        }
    },
    

    
}
</script>
<style lang="">
    
</style>